import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getAdmindeshboard = createAsyncThunk(
  "/party/adminGetEmployee",
  async ({ project }) => {
    try {
      const myurl = `${V_URL}/admin/get-admin-dashboard?project=${project}`;

      const response = await axios({
        method: "get",
        url: myurl,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
        },
      });

      const data = response.data;
      // console.log(data, "adminGetEmployee response");

      if (data.success === true) {
        return data;
      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.log(error, "error");
      toast.error(error.response.data.message);
      return error;
    }
  }
);

const getAdmindeshboardSlice = createSlice({
  name: "getAdmindeshboard",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdmindeshboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdmindeshboard.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getAdmindeshboard.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getAdmindeshboardSlice.reducer;
